import React from 'react';
import PropTypes from 'prop-types';
import {
  NavigationImageBlocks,
  NavigationStreamlined,
  NavigationFeaturedProducts,
} from '@cotyorg/ccx-organism-navigation';

const navTypeStreamlined = 'streamlined';
const navTypeImageBlocks = 'imageBlocks';
const navTypeFeaturedProducts = 'featuredProducts';

const NavigationTypes = {
  [navTypeStreamlined]: <NavigationStreamlined />,
  [navTypeImageBlocks]: <NavigationImageBlocks />,
  [navTypeFeaturedProducts]: <NavigationFeaturedProducts />,
};

const HeaderNav = ({ navCssClass, navType }) => (
  <div className={navCssClass}>
    { NavigationTypes[navType] }
  </div>
);

HeaderNav.propTypes = {
  navCssClass: PropTypes.string,
  navType: PropTypes.oneOf(Object.keys(NavigationTypes)),
};

HeaderNav.defaultProps = {
  navType: navTypeStreamlined,
};

export default HeaderNav;
